import styled, { css } from 'styled-components'

import { pulseAnimate } from '~/styles/shared/pulseAnimate'

import {
  InputStructureProps,
  LabelContainerProps,
  LabelLeftProps,
  LabelProps,
  RightAreaElementContainerProps,
  StyledInputProps
} from './type'

export const ComponentStructure = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

export const StyledInput = styled.input<StyledInputProps>`
  font-family: 'Barlow';
  color: #303032;
  outline: none;
  border: none;

  ${({ theme, heightClass }) => css`
    padding: ${theme.input[heightClass]?.paddingY ?? 0}px 8px;
    font-size: ${theme.input[heightClass]?.fontSize}px;
    line-height: ${theme.input[heightClass]?.lineHeight}px;
  `}

  width: 100%;
  background: transparent;

  ${({ informational }) => informational && 'cursor: default;'}

  ${({ informational, component }) =>
    informational && component === 'textarea' && 'resize: none;'}

  &::placeholder {
    color: #abbed1;
  }

  ${({ autoComplete, disabled, informational }) =>
    autoComplete === 'off' && !disabled && !informational && 'cursor: pointer'}

  ${({ disabled }) => disabled && 'cursor: not-allowed;'}
`

export const RightAreaElementContainer = styled.div<RightAreaElementContainerProps>`
  display: inline-flex;

  ${({ theme, heightClass }) => css`
    padding-top: ${theme.input[heightClass]?.paddingY ?? 0}px;
    padding-right: ${theme.input[heightClass]?.paddingX ?? 0}px;
    padding-bottom: ${theme.input[heightClass]?.paddingY ?? 0}px;
    padding-left: 0px;
  `}
`

export const LabelContainer = styled.div<LabelContainerProps>`
  display: flex;
  justify-content: space-between;

  ${({ theme, heightClass }) => css`
    margin-bottom: ${theme.input[heightClass]?.labelAreaMargin}px;
  `}
`

export const LabelLeftArea = styled.div<LabelLeftProps>`
  display: flex;
  align-items: center;

  ${({ theme, heightClass }) => css`
    column-gap: ${theme.input[heightClass]?.labelSpaceBetween}px;
  `}
`

export const Label = styled.label<LabelProps>`
  margin-bottom: 0;

  ${({ theme, heightClass }) => css`
    line-height: ${theme.input[heightClass]?.labelLineHeight}px;
    font-size: ${theme.input[heightClass]?.labelSize}px;
  `}

  ${({ required }) =>
    required &&
    css`
      font-weight: 700;
    `}
`

export const InputStructure = styled.div<InputStructureProps>`
  display: inline-flex;

  ${({ statusClass = 'default', theme }) => css`
    border: 2px solid ${theme.colors.status[statusClass]};
  `};

  ${({ disabled, informational }) =>
    disabled &&
    !informational &&
    css`
      border-style: dashed;
    `}

  ${({ informational }) =>
    informational &&
    css`
      border-width: 2px 0 0 0;
    `}
  
  ${({ nonFocusable, informational, theme, heightClass }) =>
    !nonFocusable &&
    !informational &&
    css`
      border-radius: ${theme.input[heightClass]?.borderRadius}px;
    `}

  ${({ component, theme, heightClass }) =>
    component === 'textarea'
      ? css`
          min-height: ${theme.input[heightClass]?.boxHeight};
        `
      : css`
          height: ${theme.input[heightClass]?.boxHeight};
        `}

  ${({ informational, statusClass = 'default', theme }) =>
    !informational &&
    css`
      &:focus-within {
        outline: 1px solid ${theme.colors.status[statusClass]};
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}

  ${({ pulseAnimate: mode, theme, statusClass = 'default' }) =>
    mode && pulseAnimate(mode, theme.colors.status[statusClass], '2px')}
`

export const VisibilityIcon = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
`

export const ActionContainer = styled.div`
  width: 40%;
`
